import axios from '@/libs/axios';
import { ErrorMessage } from '@/libs/Error';

export default class BoletosClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getBoletoList(query) {
    try {
      return await this.api.get('boleto/list', { params: query });
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar lista de boletos');
    }
  }

  async genereteBoleto(data) {
    try {
      return await this.api.post('boleto/gerarBoletoPedido', { params: data },
        {
          headers: {
            'Content-Type': 'multipart/form-data; boundary=---011000010111000001101001',
          },
          responseType: 'blob',
        });
    } catch (error) {
      throw this.error.message(error, 'Erro ao gerar boleto');
    }
  }
}
